import React, { useEffect, useState } from 'react';
// logic
import ticketService from 'modules/emergencies/ticketService';
// components
import { FormButton } from '../ui/buttons/FormButton';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import {
  ModalContainer,
  CloseButtonContainer,
  ModalBody,
  ModalFooter,
  ModalFormContainer,
  ModalHeader,
  ModalHeaderInnerContainer,
  ModalHeaderMainText,
  ModalHeaderSecondaryText,
  ModalBoldText,
  ModalRegularText,
} from './modalComponents';
import useSWR from 'swr';
import { Input } from '@ontruck/fe-ui';
import { getTicketAgencies } from 'modules/emergencies/api/getTicketAgencies';

const t = {
  confirm: 'Confirm movement to TMS',
  back: 'Back',
  title: 'Do you want to mark this ticket as moved to TMS?',
  subtitle: 'Select the agency for this ticket:',
  warning: 'This action cannot be undone.',
};
export const MoveToTMSModal = ({ ok, cancel, moveToTMSModalProps }) => {
  const { ticket = {} } = moveToTMSModalProps;
  const ticketId = ticket.id;

  const { data: agencies, error: agenciesError } = useSWR(
    `/tickets/${ticketId}/available-agencies/`,
    () => getTicketAgencies(ticketId),
    {
      errorRetryCount: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const isLoadingAgencies = agencies === undefined && agenciesError === undefined;

  const defaultAgency = undefined;

  const agenciesOptions = !isLoadingAgencies
    ? agencies?.map((agency) => ({
        label: agency.name,
        value: agency.id,
      }))
    : [];

  const formattedTicketId = ticketService.utils.getFormatedId(ticket.id);
  const [selectedAgencyId, setSelectedAgencyId] = useState(defaultAgency);
  // errros are not visible at the beggining
  const [hasError, setHasError] = useState(false);

  // once agencies are done loading
  // if there is only one agency, set it as the selected one
  useEffect(() => {
    if (!isLoadingAgencies && agenciesError === undefined && agencies.length === 1)
      setSelectedAgencyId(agencies[0].id);
  }, [agencies, agenciesError, isLoadingAgencies]);

  const goBack = (e) => {
    e.preventDefault();
    cancel();
  };

  // if the agency is not selected, display errors
  const onSubmit = () => {
    if (selectedAgencyId !== undefined) ok({ selectedAgencyId });
    else setHasError(true);
  };
  return (
    <ModalContainer>
      <ModalBody>
        <ModalHeader>
          <ModalHeaderInnerContainer>
            <ModalHeaderSecondaryText>{`Ticket ID. ${formattedTicketId}`}</ModalHeaderSecondaryText>
            <ModalHeaderMainText>{t.title}</ModalHeaderMainText>
          </ModalHeaderInnerContainer>
        </ModalHeader>
        <ModalFormContainer>
          <ModalRegularText>{t.subtitle}</ModalRegularText>
          {!isLoadingAgencies && (
            <Input
              handleChangeValue={(name, value) => {
                setSelectedAgencyId(value);
              }}
              hasError={hasError}
              label="Agency"
              name="agency"
              options={agenciesOptions}
              type="select"
              value={selectedAgencyId}
              width="100%"
            />
          )}
          <ModalBoldText>{t.warning}</ModalBoldText>
        </ModalFormContainer>
      </ModalBody>
      <ModalFooter>
        <FormButton variant="ghost" onClick={goBack}>
          {t.back}
        </FormButton>
        <FormButton onClick={onSubmit}>{t.confirm}</FormButton>
      </ModalFooter>
      <CloseButtonContainer onClick={goBack}>
        <CloseIcon />
      </CloseButtonContainer>
    </ModalContainer>
  );
};
